import axios from "axios";

import { getHeader } from "../headers";

// ===================================================================================
//  GET BANNERS
// ===================================================================================
export const bannersAreLoading = () => {
	// console.log('banners are now loading')
	return {
		type: "BANNERS_ARE_LOADING"
	};
};

export const bannersHasError = err => {
	// console.log('banners have error')
	return {
		type: "BANNERS_HAS_ERROR",
		hasErrored: true,
		error: err
	};
};

export const bannersSuccess = data => {
	// console.log('banners have successfully loaded')
	return {
		type: "BANNERS_SUCCESS",
		data
	};
};

export function getBanners() {
	return dispatch => {
		dispatch(bannersAreLoading());

		return axios
			.get(process.env.REACT_APP_API_URL + "banners", {
				headers: getHeader()
			})
			.then(response => {
				dispatch(bannersSuccess(response));
			})
			.catch(err => {
				console.log("getBanners error:", err.response);
				dispatch(bannersHasError(err.response.data.message));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/banners.js